module.exports = __webpack_public_path__ + "static/media/02.c2ec4a56.png";